import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Feedback from "../../components/feedbackNote/Feedback";
import { GetHomeData, selectHomeData } from "../../features/home/homeSlice";
import {
  GetLogsTracker,
  selectLogsTracker,
} from "../../features/login/logsTracker";
import { GetUserPermisionData } from "../../features/rolebase/userPermissionSlice";
import LeadersMessages from "./sections/LeadersMessages";
import MobLeadersMessages from "./sections/MobLeadersMessages";
import RecentUpdates from "./sections/RecentUpdates";
import ReportCodeOfConductViolations from "./sections/ReportCodeOfConductViolations";
import {
  GetMessages,
  selectMessages,
} from "../../features/messages/messageSlice";
import {
  GetRecentUpdatesData,
  selectRecentUpdatesData,
} from "../../features/home/recentUpdatesSlice";
import Contact from "../help/sections/Contact";
import {
  GetContacts,
  selectContacts,
} from "../../features/helpandassistance/contactsSlice";
import { GetCounsellors } from "../../features/helpandassistance/counsellorSlice";
import { isPermited } from "../../features/localStorage";
import DeclarationsNew from "../help/sections/DeclarationsNew";
import EthicsConcerns from "./sections/EthicsConcerns";
import ConflictOfInterest from "./sections/ConflictOfInterest";
import { GetUserDetailsAsync, selectUserDetails } from '../../features/helpandassistance/DeclarationSlice';

function Home() {
  const homeData = useAppSelector(selectHomeData);
  const dispatch = useAppDispatch();
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const LogsTracker = useAppSelector(selectLogsTracker);
  const messagesList = useAppSelector(selectMessages);
  const updatesData = useAppSelector(selectRecentUpdatesData);
  const contacts = useAppSelector(selectContacts);
  const coiUserData = useAppSelector(selectUserDetails);
  localStorage.setItem("userPhotoDetails", JSON.stringify(homeData?.user));
  let userPermission: any = localStorage.getItem("URP");
  var moduleName = "Home";
  
  useEffect(() => {
    dispatch(GetUserDetailsAsync());
  }, []);

  useEffect(() => {
    async function fetchHomeData() {
      let sample = await dispatch(GetHomeData(userDetailsJson));
    }
    fetchHomeData();
    async function fetchLogsTracker() {
      let sample = await dispatch(GetLogsTracker(moduleName));
    }
    fetchLogsTracker();
    async function fetchUserPermission() {
      let sample = await dispatch(GetUserPermisionData());
    }
    fetchUserPermission();
    async function fetchMessages() {
      await dispatch(GetMessages());
    }
    fetchMessages();

    var searchParams = {
      companyId: 0,
      keyword: "*",
    };

    async function fetchCounsellors() {
      await dispatch(GetCounsellors(searchParams));
    }
    fetchCounsellors();

    async function fetchContacts() {
      await dispatch(GetContacts(searchParams));
    }
    fetchContacts();

    // var data = 0;
    // async function fetchRecentData() {
    //   let sample = await dispatch(GetRecentUpdatesData(data));
    // }
    // fetchRecentData();
  }, []);

  // const displayCOI = useMemo(() => {
  //   return isPermited(14, 1);
  // }, [userPermission]);

  return (
    <>
      {/* <EmptyRow></EmptyRow> */}
      <div className='mob'>
        <p style={styles.home}>Home</p>
      </div>
      {}

      <Feedback pageName='home' />

      {/* <AnnualCompliance  GetAnnualData={homeData?.annual}/> */}
      <div className='desk'>
        <Row>
          <Col
            sm={8}
            style={{
              backgroundColor: '#ffffff',
              height: 'inherit'
            }}
          >
            <EthicsConcerns />
          </Col>
          <Col sm={4} style={{ height: 'inherit' }}>
            <LeadersMessages messagesList={messagesList} />
          </Col>
          {!!coiUserData?.mandmEmployee && (
            <Col xs={12} className='p-0 mt-3'>
              <div className='rowBg1'>
                <Row style={{ padding: '5px' }}>
                  <Col xs={12}>
                    {/* <DeclarationsNew /> */}
                    <ConflictOfInterest />
                  </Col>
                </Row>
              </div>
            </Col>
          )}
        </Row>
      </div>

      <div className='mob'>
        <Row
          style={{
            backgroundColor: '#ffffff',
            padding: '20px',
            height: 'auto'
          }}
          className='b_shadow'
        >
          <ReportCodeOfConductViolations
            GetcodeOfConductData={homeData?.codeOfConduct}
          />
        </Row>

        <br />

        <MobLeadersMessages messagesList={messagesList} />

        <br />

        {/* <Row>
          <RecentUpdates updatesData={updatesData} />
        </Row> */}
      </div>
    </>
  );
}

const styles: any = {
  home: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "800",
    marginTop: "10px",
  },
};

export default Home;
